import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { Shield } from "lucide-react";

export default function AdminLogin() {
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const res = await api.adminLogin(email, password);
      setSession(res);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="pt-32 min-h-screen max-w-md mx-auto px-6">
      <div className="border border-white/10 bg-[color:var(--bg-surface)] p-8">
        <div className="uj-bar mb-8 -mx-8" />
        <Shield className="w-6 h-6 text-[color:var(--accent-red)] mb-4" />
        <div className="eyebrow mb-3">/ STAFF ACCESS</div>
        <h1 className="font-display text-white text-4xl leading-none mb-8">Command Centre.</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="eyebrow block mb-2">EMAIL</label>
            <input
              data-testid="admin-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              className="terminal-input"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="eyebrow block mb-2">PASSWORD</label>
            <input
              data-testid="admin-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              className="terminal-input"
              autoComplete="current-password"
            />
          </div>
          {error && <div className="font-mono text-[11px] text-[color:var(--accent-red)]">{error}</div>}
          <button
            data-testid="admin-login-submit"
            disabled={busy}
            className="btn-brutal w-full h-11 border border-white/15 text-white font-mono text-[11px] tracking-[0.24em] uppercase disabled:opacity-50"
          >
            {busy ? "Verifying..." : "Enter Command Centre"}
          </button>
        </form>
      </div>
    </main>
  );
}
